import React from "react"
import { IconButton, FontIcon } from "material-ui"
import { ITimeoffRequestDocument, ETimeoffStatus } from "../../../models"
import LeaveTrackingTable from "./LeaveTrackingTable"
import * as permissionHelper from "../../../helpers/permissionHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import AppStateStore from "../../../stores/AppStateStore"
import strings from "../../../localization/strings"
import LeaveTrackingNotesDrawer from "../LeaveTrackingNotesDrawer"
import * as leaveTrackingActions from "../../../actions/LeaveTrackingActions"
interface IProps {
    showStatuActionBar: boolean
    leaveRequests: ITimeoffRequestDocument[]
    updateStatusCb(): void

    readonly?: boolean
    handleSelect?(leaveRequests: ITimeoffRequestDocument[]): void
    handleUpdate?(leaveRequest: ITimeoffRequestDocument): void

    //pagination
    total?: number
    limit?: number
    offset?: number
    limitOption?: number[]
    onPageClick?(offset: number): void
    onLimitChange?(limit: number): void

    //from PunchSetExceptions
    unapprovedException?: boolean
    showEmployeeExternalId?: boolean
}
interface IState {
    selectedLeaveRequests: ITimeoffRequestDocument[]
    leaveRequestForDrawerId: string
}

export default class LeaveTrackingLiveView extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            selectedLeaveRequests: [],
            leaveRequestForDrawerId: null
        }
    }

    handleUpdateLeaveRequestsStatus(status: ETimeoffStatus, leaveRequests: ITimeoffRequestDocument[]) {
        leaveRequests.length === 0 ?
            AppStateStore.setProgressSnackbarContent(status === ETimeoffStatus.Approved ? strings.Choose_leave_requests_to_approve : strings.Choose_leave_requests_to_deny) :
            AppStateStore.setConfirmDialogContent({
                content: status === ETimeoffStatus.Approved ? strings.Are_you_sure_you_want_to_approve_selected_leave_request : strings.Are_you_sure_you_want_to_deny_selected_leave_request,
                confirm: () => leaveTrackingActions.handleUpdateStatus(status, leaveRequests, this.props.updateStatusCb)
            })
    }

    render() {
        return (
            <div>
                {permissionHelper.hasPermission(AuthenticationStore.Permissions.LeaveTracking.EditLeaveTracking) &&
                    <div style={{ textAlign: "right", paddingLeft: 10, paddingRight: 10, height: 48 }}>
                        {this.props.showStatuActionBar && [
                            <IconButton
                                data-intercom-target={"LeaveTracking-ApproveLeaveRequest"}
                                key="approve"
                                onClick={() => this.handleUpdateLeaveRequestsStatus(ETimeoffStatus.Approved, this.state.selectedLeaveRequests)}
                            >
                                <FontIcon className="fa fa-check" color={"rgb(97, 97, 97)"} />
                            </IconButton>,
                            <IconButton
                                data-intercom-target={"LeaveTracking-DenyLeaveRequest"}
                                key="deny"
                                onClick={() => this.handleUpdateLeaveRequestsStatus(ETimeoffStatus.Denied, this.state.selectedLeaveRequests)}
                            >
                                <FontIcon className="fa fa-remove" color={"rgb(97, 97, 97)"} />
                            </IconButton>
                        ]}
                    </div>
                }
                <LeaveTrackingTable
                    unapprovedException={this.props.unapprovedException}
                    showEmployeeExternalId={this.props.showEmployeeExternalId}
                    total={this.props.total}
                    limit={this.props.limit}
                    offset={this.props.offset}
                    limitOption={this.props.limitOption}
                    readonly={this.props.readonly}
                    leaveRequests={this.props.leaveRequests}
                    onPageClick={this.props.onPageClick}
                    onLimitChange={this.props.onLimitChange}
                    handleUpdate={this.props.handleUpdate}
                    handleSelect={selectedLeaveRequests => {
                        this.setState({ selectedLeaveRequests })
                        this.props.handleSelect &&
                            this.props.handleSelect(selectedLeaveRequests)
                    }}
                    handleNotesDrawer={leaveRequestForDrawerId => this.setState({leaveRequestForDrawerId})}
                />
                <LeaveTrackingNotesDrawer
                    open={this.state.leaveRequestForDrawerId ? true : false}
                    leaveRequestId={this.state.leaveRequestForDrawerId}
                    handleClose={() => this.setState({ leaveRequestForDrawerId: null })}
                />
            </div>
        )
    }
}